import axios from "axios";
import APIRoutes from "../../APIRoutes";

import { getAPIRoot } from "../../../utils/GeneralUtils";
import {
  SonicGameSelection,
  SonicGameSelectionData,
} from "../../../common/classes/SonicGameSelection";

/**
 * getGameSelections
 *
 * Fetches game selections data.
 *
 * @returns An array of game selection.
 */

export const getGameSelections = async (
  signal?: AbortSignal
): Promise<SonicGameSelectionData[] | null> => {
  try {
    const res = await axios.get(getAPIRoot(APIRoutes.get.game_selections), {
      signal,
    });

    if (res.data.result === false) return null;

    const game_selections: Array<SonicGameSelectionData> = [];

    res.data.message.forEach((e: any) => {
      const game_selection = SonicGameSelection.parseFromAPIResponse(e);
      game_selections.push({ ...game_selection });
    });

    return game_selections;
  } catch (e) {
    return null;
  }
};
